import { type BaseCurrencyType } from '@pkg/types';
import { assertNumber, regexPattern, roundNumber } from '@pkg/utils';

import { PRETTY_DECIMALS } from '@app/store/zustand';

import { type InputPriceType } from './AssetListingSheet.types';

export function filterInputPrice(value?: InputPriceType) {
    if (value === undefined) return undefined;

    const trimmed = typeof value === 'string' ? value.trim() : value;
    const normalized = trimmed.toString();
    const firstFloat = normalized.match(regexPattern.capture.float)?.[0];

    return firstFloat?.length ? parseFloat(firstFloat) : undefined;
}

export function formatInputPrice(value?: InputPriceType, currencyType: BaseCurrencyType = 'usd') {
    const filtered = filterInputPrice(value);
    const decimals = currencyType === 'usd' ? PRETTY_DECIMALS.usd : PRETTY_DECIMALS.crypto.full;
    const formatted = assertNumber(filtered) ? roundNumber(filtered, decimals) : undefined;

    return formatted;
}
